// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headers[data-v-9b630720]{display:grid;grid-template-columns:5fr repeat(4,1fr) 16px;grid-gap:16px;font-family:Roboto Mono,monospace;font-size:12px;text-align:right;margin-bottom:16px}.headers .size-field[data-v-9b630720]:first-letter{text-transform:uppercase}", ""]);
// Exports
module.exports = exports;
